import React from "react";
import { Link } from "@sonder/ui/source/styled/fragments/Link";
import { useSegment } from "analytics/segment";

interface ExternalLinkProps {
  children?: React.ReactNode;
  href: string;
  segmentOnClickEvent: SegmentEvent;
}
export const ExternalLink = ({
  children = "Open in new tab",
  href,
  segmentOnClickEvent,
}: ExternalLinkProps) => {
  const { track } = useSegment();
  return (
    <Link
      href={href}
      target="_blank"
      onClick={() => track(segmentOnClickEvent)}
    >
      {children}
    </Link>
  );
};
